export default __webpack_public_path__ + "static/media/header-two.48ffc28d.svg";